export enum RoleType {
	IT_Admin = 0,
	HPS_SWO_Sup_EO = 1,
	SOT = 2,
	OIC_AOIC_CL = 3,
	CW = 4,
	CW_Ltd_rights = 5,
	AA_Clerk = 6,
	PW_Admin = 7,
	MHEO_PW = 8,
	PSW_CPSW = 9,
}
